/**
 * Common query keys used throughout the application
 */
export const QUERY_KEYS = {
    // Main data categories
    TRANSACTIONS: 'transactions',
    TAX_REPORTS: 'taxReports',
    INTEGRATIONS: 'integrationsOverview',
    INTEGRATIONS_TOKEN_ALLOCATION: 'integrationsTokenAllocation',
    RECALCULATION: 'recalculateInfo',
    REFRESH_BALANCE: 'refreshBalance',
    USER_NOTIFICATIONS: 'userNotifications',
    
    // Smart Check specific keys
    ALL_TIME_ISSUES: 'allTimeIssuesWithDetails',


    // Tax report specific keys
    REPORT_SUMMARY: 'reportSummary',
    TRANSACTION_STATS: 'transactionStats',
    ALL_TIME_ISSUE_COUNT: 'allTimeIssueCount',
    TAX_PERSONAL_DATA: 'taxPersonalData',

    // Admin specific keys
    ADMIN_USERS: 'adminUsers',
    ADMIN_USER_PLANS: 'adminUserPlans',
    ADMIN_USER_LOGS: 'adminUserLogs',
    ADMIN_INDIVIDUAL_PLAN: 'adminIndividualPlan',
    // Helper function to invalidate all main data queries
    taxQueries: () => [
        QUERY_KEYS.TAX_REPORTS,
        QUERY_KEYS.REPORT_SUMMARY,
        QUERY_KEYS.TRANSACTION_STATS,
        QUERY_KEYS.ALL_TIME_ISSUE_COUNT,
        // QUERY_KEYS.TAX_PERSONAL_DATA,
    ],
    transactionsQueries: () => [
        QUERY_KEYS.TRANSACTIONS,
    ],
    dataQueries: () => [
        QUERY_KEYS.INTEGRATIONS,
        QUERY_KEYS.INTEGRATIONS_TOKEN_ALLOCATION,
        QUERY_KEYS.USER_NOTIFICATIONS,
        QUERY_KEYS.ALL_TIME_ISSUES,
    ],
    allQueries: () => [...QUERY_KEYS.dataQueries(), ...QUERY_KEYS.transactionsQueries(), ...QUERY_KEYS.taxQueries()],
};
